// Define the configuration object as the source of truth
export const featureFlags = {
    COUNTER_SIGN_ON_SEND: {
        name: 'provider counter-sign on send',
        openInE2eTests: true,
        owner: 'anna.y@sayanchor.com'
    },
    EMPTY_TEMPLATE_CUSTOM_PAGES: {
        name: 'empty custom pages in proposal templates',
        openInE2eTests: true,
        owner: 'anna.y@sayanchor.com'
    },
    WIP_AMENDMENTS: {
        name: 'save for later amendments made to an approved agreement',
        openInE2eTests: false,
        owner: 'meital@sayanchor.com'
    },
    RENAME_AGREEMENT_ENDPOINT: {
        name: 'New endpoint dedicated for renaming agreement name',
        openInE2eTests: true,
        owner: 'meital@sayanchor.com'
    },
    AGREEMENTS_APPROVAL_DATE_FILTER: {
        name: 'approval date filter on the agreements dashboard',
        openInE2eTests: true,
        owner: 'elad@sayanchor.com'
    },
    DISABLE_BILLING_SCAN: {
        name: 'Kills bill...ing',
        openInE2eTests: false,
        owner: 'leeor@sayanchor.com'
    },
    AUTOMATIC_STAGES: {
        name: 'per-stage scheduling on bill-in-stages services',
        openInE2eTests: true,
        owner: 'ben@sayanchor.com'
    },
    CONNECTED_APPS_PAGE: {
        name: 'new page that shows all connected integrations',
        openInE2eTests: true,
        owner: 'meital@sayanchor.com'
    },
    PER_LINE_ITEM_REFUNDS: {
        name: 'per-line-item refund modal (ANCR-3122)',
        openInE2eTests: true,
        owner: 'aviv@sayanchor.com'
    },
    TEMPLATE_VARIABLES: {
        name: 'Template variables in Agreement Studio',
        owner: 'leeor@sayanchor.com',
        openInE2eTests: false
    },
    CUSTOM_VARIABLES: {
        name: 'custom (user-defined) template variables',
        owner: 'leeor@sayanchor.com',
        openInE2eTests: true
    },
    UPDATE_DEFAULT_TOS_FE: {
        name: 'content of Anchor default tos changed',
        openInE2eTests: false,
        owner: 'meital@sayanchor.com'
    },
    BULK_AGENTIC_DRAFTS: {
        name: 'bulk agentic drafting pane on DraftsDashboard (ANCR-36)',
        openInE2eTests: false,
        owner: 'ahuvi@sayanchor.com'
    },
    BULK_CREATE_PROPOSALS: {
        name: 'Sellers can create and send proposals to many clients in one action and track it',
        openInE2eTests: true,
        owner: 'meital@sayanchor.com'
    },
    HELP_ME_WRITE_NOTIFICATIONS: {
        name: 'AI-assisted "help me write" drawer for notification settings (ANCR-1500)',
        openInE2eTests: true,
        owner: 'daniel@sayanchor.com'
    },
    EDIT_PROPOSAL_IN_PLACE: {
        name: 'edit proposal in place',
        openInE2eTests: true,
        owner: 'leeor@sayanchor.com'
    },
    PAYOUTS_EXTERNAL_API: {
        name: 'move the FE to use the new payout endpoint',
        openInE2eTests: false,
        owner: 'meital@sayanchor.com'
    },
    EXTERNAL_INVOICES_ENDPOINT: {
        name: 'move the FE to use the new invoice endpoints',
        openInE2eTests: false,
        owner: 'meital@sayanchor.com'
    },
    NOTIFICATION_CONTENT_CUSTOMIZATION: {
        name: 'Customized Notifications Content',
        openInE2eTests: true,
        owner: 'daniel@sayanchor.com'
    },
    AGREEMENTS_CSV_EXPORT_V2: {
        name: 'agreements dashboard CSV export with services (one row per service)',
        openInE2eTests: true,
        owner: 'leeor@sayanchor.com'
    },
    ENABLE_DRAFTS_AI_SEARCH: {
        name: 'natural-language drafts search input + chips on the drafts dashboard (ANCR-36)',
        openInE2eTests: false,
        owner: 'idan.s@sayanchor.com'
    },
    ENABLE_AGREEMENTS_AI_SEARCH: {
        name: 'natural-language agreements search input + fixed-control materialization on the agreements dashboard (ANCR-2411)',
        openInE2eTests: false,
        owner: 'ben@sayanchor.com'
    },
    PING_INTEGRATION: {
        name: 'Ping integration card on Available Apps page (Communications section)',
        openInE2eTests: false,
        owner: 'leeor@sayanchor.com'
    },
    ABACOR_INTEGRATION: {
        name: 'Abacor integration card on Available Apps page (Communications section)',
        openInE2eTests: true,
        owner: 'moran@sayanchor.com'
    },
    ZAPIER_TEMPLATE_INTEGRATIONS: {
        name: 'Zapier-template integration tiles and pages on the Integrations page',
        openInE2eTests: false,
        owner: 'moran@sayanchor.com'
    },
    PAYMENT_RECEIPT_PDF: {
        name: 'on-demand payment receipt PDF download from the FullPageInvoice header dropdown',
        openInE2eTests: true,
        owner: 'leeor@sayanchor.com'
    },
    CREDIT_LIFECYCLE_ACTIVITY_ENTRIES: {
        name: 'credit lifecycle entries (added/paused/resumed/canceled) on the activity log (ANCR-3739)',
        openInE2eTests: true,
        owner: 'anna.y@sayanchor.com'
    },
    AGREEMENT_IMPORT_TRANSCRIPT: {
        name: 'allow to import txt files of transcript in the import agreement flow',
        openInE2eTests: false,
        owner: 'meital@sayanchor.com'
    },
    ANALYST_AGENT: {
        name: 'analyst agent chat on the vendor dashboard',
        openInE2eTests: true,
        owner: 'leeor@sayanchor.com'
    },
    SELF_SERVICE_TAX_UPDATE: {
        name: 'self-service "Update tax details" action launching a Persona tax-update inquiry (ANCR-2948)',
        openInE2eTests: false,
        owner: 'leeor@sayanchor.com'
    },
    SALES_TAX: {
        name: 'sales tax feature — SP tax config, per-service taxable, per-client exemption, invoice tax rendering (ANCR-20)',
        openInE2eTests: true,
        owner: 'aviv@sayanchor.com'
    },
    REFERENCE_FIELDS: {
        name: 'reference fields on proposals, agreements, invoices (ANCR-2541)',
        openInE2eTests: true,
        owner: 'guy.w@sayanchor.com'
    },
    NATIVE_PUSH: {
        name: 'native mobile push notifications',
        openInE2eTests: true,
        owner: 'ahuvi@sayanchor.com'
    },
    BULK_AGENTIC_AMENDMENTS: {
        name: 'bulk agentic amendments pane on AgreementsDashboard (ANCR-788)',
        openInE2eTests: true,
        owner: 'anna@sayanchor.com'
    },
    BILLING_TIMELINE: {
        name: 'billing timeline pane in agreement studio (ANCR-334)',
        openInE2eTests: true,
        owner: 'ahuvi@sayanchor.com'
    },
    CRM_CONTACTS: {
        name: 'contacts table rebuilt on shared contact identities, plus per-client roles (ANCR-2711)',
        openInE2eTests: false,
        owner: 'anna.y@sayanchor.com'
    },
    PULSE_OPPORTUNITIES: {
        name: 'ranked revenue-opportunity widget on the vendor dashboard (ANCR-4934)',
        openInE2eTests: true,
        owner: 'leeor@sayanchor.com'
    },
    POST_APPROVAL_INTAKE_LINKS: {
        name: 'post-approval intake links: signed-page links block + "Post-approval steps" shell in studio and proposal defaults + the "With intake links" variant tab in notification settings (ANCR-5058)',
        openInE2eTests: true,
        owner: 'leeor@sayanchor.com'
    },
    SHARED_PROPOSAL_LINK: {
        name: 'shared proposal link — verify by email (ANCR-2256)',
        openInE2eTests: true,
        owner: 'daniel@sayanchor.com'
    },
    VOB_BOOK_A_DEMO: {
        name: 'demo-booking variant of the vendor onboarding final screen for high-volume new signups',
        openInE2eTests: false,
        owner: 'moran@sayanchor.com'
    },
    STANFORD_TAX_INTEGRATION: {
        name: 'StanfordTax integration: the "Tax workflow" available-apps section with its card and connect overlay, plus the StanfordTax manage route (ANCR-5574)',
        openInE2eTests: true,
        owner: 'leeor@sayanchor.com'
    },
    APPCUES_LATEST_SDK: {
        name: 'load the Appcues SDK from the Appcues CDN instead of the stale self-hosted v4 bootstrap (ANCR-5935)',
        openInE2eTests: true,
        owner: 'ahuvi@sayanchor.com'
    },
    PDF_EMBEDDED_SIGNATURES: {
        name: 'collect e-signatures on Terms of Service PDFs: signatory roles and embedded field placement (ANCR-3305)',
        openInE2eTests: true,
        owner: 'anna.y@sayanchor.com'
    },
    SEAGULL_TABLES: {
        name: 'tables rebuilt on the seagull DataTable/StaticTable/SummaryTable components (ANCR-4901)',
        openInE2eTests: true,
        owner: 'aviv@sayanchor.com'
    },
    CLIENT_ADDRESS: {
        name: 'client address: client modal, client details card, ask-client checkbox, client portal address, invoice address row, shared address form (ANCR-2712)',
        openInE2eTests: true,
        owner: 'aviv@sayanchor.com'
    },
    CLIENT_REFERENCE_FIELDS: {
        name: 'client reference fields: client modal section, client details card subsection (ANCR-6004)',
        openInE2eTests: true,
        owner: 'aviv@sayanchor.com'
    },
    REFERENCE_FIELDS_HINTS: {
        name: 'reference fields hints: field name suggestions + value already-in-use hint on client and agreement reference fields (ANCR-6178)',
        openInE2eTests: true,
        owner: 'aviv@sayanchor.com'
    },
    SERVICE_REFERENCE_FIELDS: {
        name: 'service reference fields: service editor and bundle editor sections, services CSV import reference-field columns (ANCR-6114)',
        openInE2eTests: true,
        owner: 'aviv@sayanchor.com'
    },
    TEXT_ALIGNMENT_IN_RICH_TEXT: {
        name: 'Add support for text alignment in rich text editors',
        openInE2eTests: true,
        owner: 'moran@sayanchor.com'
    },
    OUTLOOK_MAILBOX_UNAVAILABLE_MODAL: {
        name: 'explain a Microsoft account with no usable Outlook mailbox in a modal instead of the generic failed-to-connect toast (ANCR-5907)',
        openInE2eTests: true,
        owner: 'matan@sayanchor.com'
    },
    PROPOSAL_TEMPLATE_DUPLICATE: {
        name: 'duplicate a proposal template from the proposal templates row menu (ANCR-6679)',
        openInE2eTests: true,
        owner: 'matan@sayanchor.com'
    },
    ANY_ONE_SIGN: {
        name: 'let a proposal be approved by the first of its signers to sign (ANCR-6909)',
        openInE2eTests: true,
        owner: 'aviv@sayanchor.com'
    },
    PROPOSAL_REAPPROVALS: {
        name: 'tell SPs and clients when edits to a sent proposal ask recipients to approve again: studio callout, publish confirmation, Proposal updated email (ANCR-5939)',
        openInE2eTests: true,
        owner: 'anna.y@sayanchor.com'
    }
};
export const FeatureFlag = Object.keys(featureFlags).reduce((acc, key)=>{
    acc[key] = key;
    return acc;
}, {});
